import type { SpaceSky, SpaceSummary, TimeOfDay } from "@mind-sands/shared";

/** Soft gradient stops [top, bottom] evoking a time of day (healing palette). */
const TIME_GRADIENTS: Record<TimeOfDay, [string, string]> = {
  dawn: ["#f6d5c3", "#e8b4a0"],
  morning: ["#cfe3ef", "#eaf2f0"],
  noon: ["#bcd9ec", "#e6f0f2"],
  afternoon: ["#c9dcea", "#f0e9d8"],
  dusk: ["#e3b98f", "#c98a7a"],
  evening: ["#5b6b8c", "#8a7a94"],
  night: ["#232a44", "#3a3f5c"],
};

/** Cosmic / special skies override the daylight gradient. */
const SKY_GRADIENTS: Partial<Record<SpaceSky, [string, string]>> = {
  starry: ["#1b2340", "#2e3557"],
  nebula: ["#2a1f3d", "#4a3560"],
  aurora: ["#16303a", "#2a5550"],
  void: ["#0d0d14", "#1a1a24"],
};

/** Derive a palette gradient for a space — used as a visual placeholder
 *  when no `thumbnailUrl` is available. Deterministic from sky + timeOfDay. */
export function spacePreviewGradient(space: SpaceSummary): string {
  const [top, bottom] =
    SKY_GRADIENTS[space.sky] ?? TIME_GRADIENTS[space.timeOfDay];
  return `linear-gradient(160deg, ${top} 0%, ${bottom} 100%)`;
}
